import { useGetDatasetByIdQuery } from "@store/api/dataset-api";
import type { VisualizationBase } from "@models/VisualizationBase";
import { getVisualizationBaseSource } from "@models/VisualizationBase";

/**
 * The base name to show in a widget footer/export. For a pre-configured base
 * this resolves the *current* name from the dataset (so a rename in Dataset
 * Configuration reflects everywhere), falling back to the cached name while the
 * dataset loads. Custom bases use their own name; no base returns "".
 */
export function useVisualizationBaseDisplayName(
  datasetId: string | null | undefined,
  base: VisualizationBase | undefined | null,
): string {
  const isPreconfigured =
    !!base?.enabled && getVisualizationBaseSource(base) === "preconfigured";

  const { data: dataset } = useGetDatasetByIdQuery(datasetId ?? "", {
    skip: !datasetId || !isPreconfigured,
  });

  if (!base?.enabled) return "";
  if (isPreconfigured) {
    const liveName = dataset?.bases?.find(
      (b) => b.id === base.preconfiguredBaseId,
    )?.name;
    return liveName ?? base.preconfiguredBaseName ?? "";
  }
  return base.name;
}
